export interface OverflowMeasurement {
  hiddenItemsTooltip: string
  hiddenItemCount: number
  ellipsisOffsetLeft: string
}

export function calcChipOverflow(chipList: NodeList): OverflowMeasurement[] {
  const chips = [];
  const measurements: OverflowMeasurement[] = [];

  chipList.forEach(element => {
    chips.push(element);
  });
  chips.forEach((chipListElement, i) => {
    const chipWrapper: Partial<HTMLElement> = chipListElement.children[0];
    let lastVisibleChip: HTMLElement;
    let lastChipTopPos = 0;
    let restAreHidden = false;
    const hiddenChipLabels = [];
    for (const child of Object.values(chipWrapper.children)) {
      const chip = child as HTMLElement;
      if (chip.classList && chip.classList.contains('mat-mdc-chip')) {
        const chipRect = chip.getBoundingClientRect();
        if (!lastChipTopPos || (!restAreHidden && lastChipTopPos === chipRect.top)) {
          lastChipTopPos = chipRect.top;
          lastVisibleChip = chip;
        } else {
          hiddenChipLabels.push(chip.innerText);
          restAreHidden = true;
        }
      }
    }
    let ellipsisOffsetLeft = '';
    if (lastVisibleChip) {
      if (chipListElement.nextElementSibling?.classList.contains('chip-ellipsis')) {
        //  If you're having issues with the offsetLeft being a huge number, we are probably measuring against 
        //  the wrong offsetParent. Try setting the parent container position to "relative"
        //  https://stackoverflow.com/a/38657027
        ellipsisOffsetLeft = lastVisibleChip.offsetLeft + lastVisibleChip.offsetWidth + 'px';
      }
    }
    measurements[i] = {
      hiddenItemsTooltip: hiddenChipLabels.join(',\n'),
      hiddenItemCount: hiddenChipLabels.length,
      ellipsisOffsetLeft,
    };
  });

  return measurements;
}
